import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessPersonnelSmartComponent } from './business-personnel-smart/business-personnel-smart.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { EditContactSmartComponent } from './edit-contact-smart/edit-contact-smart.component';
import { EditContactComponent } from './edit-contact/edit-contact.component';
import {
    BusinessPersonnelBasicComponent,
    BusinessPersonnelComponent
} from './business-personnel/business-personnel.component';
import { MatCardModule } from '@angular/material/card';
import { EditContactDialogComponent } from './edit-contact-dialog/edit-contact-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatButtonModule } from '@angular/material/button';
import { PhoneModule } from 'app/pipes/phone/phone-pipe.module';
import { MatDividerModule } from '@angular/material/divider';
import { SSNModule } from 'app/pipes/ssn/ssn-pipe.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignatureRequestSmartComponent } from './signature-request-smart/signature-request-smart.component';
import { SignatureRequestComponent } from './signature-request/signature-request.component';
import { BorrowerDataTableModule } from 'app/borrower-data-table/borrower-data-table.module';
import { EditNonOwnerPersonnelComponent } from './edit-non-owner-personnel/edit-non-owner-personnel.component';
import { BusinessNonOwnerPersonnelComponent } from './business-non-owner-personnel/business-non-owner-personnel.component';
import { EditNonOwnerPersonnelSmartComponent } from './edit-non-owner-personnel-smart/edit-non-owner-personnel-smart.component';
import { AdditionalOwnersPostOfferVerificationComponent } from './additional-owners-post-offer-verification/additional-owners-post-offer-verification.component';
import { AdditionalOwnersRequiredComponent } from './additional-owners-required/additional-owners-required.component';
import { AdditionalOwnersSmartComponent } from './additional-owners-smart/additional-owners-smart.component';
import { AddPersonnelComponent } from './add-personnel/add-personnel.component';
import { AddPersonnelSmartComponent } from './add-personnel-smart/add-personnel-smart.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        AdditionalOwnersPostOfferVerificationComponent,
        AdditionalOwnersRequiredComponent,
        AdditionalOwnersSmartComponent,
        AddPersonnelComponent,
        AddPersonnelSmartComponent,
        BusinessNonOwnerPersonnelComponent,
        BusinessPersonnelSmartComponent,
        BusinessPersonnelComponent,
        EditContactSmartComponent,
        EditContactComponent,
        EditContactDialogComponent,
        EditNonOwnerPersonnelComponent,
        EditNonOwnerPersonnelSmartComponent,
        SignatureRequestSmartComponent,
        SignatureRequestComponent,
        BusinessPersonnelBasicComponent,
    ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        PhoneModule,
        SSNModule,
        MatChipsModule,
        MatDividerModule,
        MatIconModule,
        MatExpansionModule,
        MatCardModule,
        MatDialogModule,
        AlertModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        FormlyModule,
        MatCheckboxModule,
        BorrowerDataTableModule,
        MatTooltip
    ],
    exports: [
        BusinessPersonnelSmartComponent,
        BusinessPersonnelBasicComponent
    ]
})
export class BusinessPersonnelModule { }
